export const sortDataAlphabetically = (dataToBeSorted, sortBy) => {
  const sortedData = dataToBeSorted?.sort((a, b) =>
    a[sortBy]?.localeCompare(b[sortBy])
  );
  return sortedData;
};
